module.exports = __webpack_public_path__ + "static/media/antena2.fw.91185a3a.png";